import { observer } from 'mobx-react-lite';
import { LivePersonaCardWrapper } from 'owa-groups-shared-components';
import * as React from 'react';

let styles = require('./GroupName.scss');
const classNames = require('classnames');

export interface GroupNameProps {
    displayName: string;
    emailAddress: string;
    clientScenario: string;
    className?: string;
}

const GroupName = observer(function GroupName(props: GroupNameProps) {
    return (
        <LivePersonaCardWrapper
            name={props.displayName}
            emailAddress={props.emailAddress}
            personaType={'Group'}
            className={classNames(styles.groupName, props.className)}
            clientScenario={props.clientScenario}>
            {props.displayName}
        </LivePersonaCardWrapper>
    );
});
export default GroupName;
